import { render } from "./FreeText.vue?vue&type=template&id=d26d807a&ts=true"
import script from "./FreeText.vue?vue&type=script&lang=ts"
export * from "./FreeText.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__